(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-template-v2"] && !Shopify.designMode) return;
  try {
    
  // $('#btn-submit').on('click', function(){
  //   console.log("welll");
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.section-slideshow-v1 .slick-slide').forEach(function(slide){
    slide.addEventListener('click', function(e){
      if (!e.target.closest('a, button')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
  });
});






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-registration-for"]) return;
  try {
    
  console.log("from liquid")

  } catch(e) { console.error(e); }
})();
})();
